'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var zh_TW = {
    // pay
    www_title: '小微便簽',
    update_log: '',
    slogan_text1: '小微便簽致力於方便、快捷記錄瑣事和智能任務提醒。 ',
    slogan_text2: '重要、瑣碎的事情不遺忘，讓工作和生活變得井井有條，開啟效率人生。 ',
    slogan_text3: '可以在多設備間即時云同步。 （Windows&Mac版本正在開發中）',
    slogan_h5: '小微便簽致力於方便、快捷記錄瑣事和智能任務提醒。重要、瑣碎的事情不遺忘，讓工作和生活變得井井有條，開啟效率人生。可以在多設備間即時云同步，（Windows&Mac版本正在開發中）',
    android_download: '下載APP',
    ios_download: 'AppStore安裝',
    support_system: '已支持如下平台',
    windows_button: 'Windows版',
    mac_button: 'Mac版',
    iphone_button: 'iPhone版',
    android_button: '安卓版',
    scan_download_phone: '掃描二維碼下載手機客戶端',
    content_title1: '多個設備之間即時同步',
    content_text1: '您可以在iPhone&iPad&安卓手機&安卓Pad之間，即時同步便簽以及內容。 （Windows&Mac版本正在開發中）',
    content_title2: '豐富精品便簽樣式',
    content_text2: '為您精心準備了幾十款便簽樣式，豐富多彩的記錄內容，讓記錄不再單調',
    content_title3: '多種主題背景選擇',
    content_text3: '為您精心準備了幾十款便簽樣式，換一換背景，換一換主題，換一換心情',
    content_title4: '精美小組件',
    content_text4: '可以將您的便簽放在手機桌面上，方便快速瀏覽，快速記錄，效率人生',
    content_title5: '自定義通知提醒',
    content_text5: '豐富的提醒設置，可以隨意自定義您想要提醒的時間，生日、聚會、重要的事情不再遺忘',
    content_title6: '週計劃，月計劃',
    content_text6: '將計劃分類定制，合理方便查看、記錄您的瑣事',
    support: '客戶支持',
    support_title: '小微便簽-客戶支持',
    support_text1: '如果您有任何意見和建議，敬請郵件聯繫我們\n',
    support_text2: '',
    help: ''
};

exports["default"] = zh_TW;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/zh_TW.js
// module id = 273
// module chunks = 0